/**
 * Food log service — adherence loop Fase 1.
 *
 * Photos are health data: the API streams them behind authz, so we fetch
 * them as blobs (cookies ride along via axios withCredentials) instead of
 * pointing <img> at the URL directly — that also works in dev cross-origin.
 */
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const BASE = `${API_BASE_URL}/api/v1/food-log`;

const foodLogService = {
  /**
   * Log a meal. photoFile is optional (note-only entries allowed).
   * @param {{photoFile?: File, mealType?: string, note?: string, hungerLevel?: number}} p
   */
  async createEntry({ photoFile, mealType = 'otro', note = '', hungerLevel = null }) {
    const form = new FormData();
    if (photoFile) form.append('file', photoFile);
    form.append('meal_type', mealType);
    if (note) form.append('note', note);
    if (hungerLevel) form.append('hunger_level', hungerLevel);
    const { data } = await axios.post(BASE, form);
    return data;
  },

  async getMine(limit = 30, offset = 0) {
    const { data } = await axios.get(`${BASE}/mine`, { params: { limit, offset } });
    return data;
  },

  async getPatientEntries(patientId, limit = 30, offset = 0) {
    const { data } = await axios.get(`${BASE}/patient/${patientId}`, {
      params: { limit, offset },
    });
    return data;
  },

  /** Fetch the protected photo as an object URL (caller revokes it). */
  async getPhotoObjectUrl(entryId) {
    const { data } = await axios.get(`${BASE}/${entryId}/photo`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(data);
  },

  async deleteEntry(entryId) {
    await axios.delete(`${BASE}/${entryId}`);
  },

  /** Nutritionist 1-tap reaction. emoji ∈ 👍 🎉 💪 ❤️ 🤔, comment optional. */
  async react(entryId, emoji, comment = '') {
    const { data } = await axios.post(`${BASE}/${entryId}/react`, { emoji, comment });
    return data;
  },

  async removeReaction(entryId) {
    const { data } = await axios.delete(`${BASE}/${entryId}/react`);
    return data;
  },
};

export default foodLogService;
